/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { EntityId } from '../../types/api/EntityId';

export enum CreateProjectActions {
  OPEN_CREATE_PROJECT_OVERLAY = 'OPEN_CREATE_PROJECT_OVERLAY',
  CLOSE_CREATE_PROJECT_OVERLAY = 'CLOSE_CREATE_PROJECT_OVERLAY',
}

export type CreateProjectState = {
  isOpen: boolean;
  organizationId?: EntityId;
};

export type OpenCreateProjectOverlayParams = {
  organizationId?: EntityId;
};

type OpenCreateProjectOverlayAction = {
  type: CreateProjectActions.OPEN_CREATE_PROJECT_OVERLAY;
  payload: OpenCreateProjectOverlayParams;
};
type CloseCreateProjectOverlayAction = {
  type: CreateProjectActions.CLOSE_CREATE_PROJECT_OVERLAY;
};

export type CreateProjectActionTypes = OpenCreateProjectOverlayAction | CloseCreateProjectOverlayAction;
